import parse from 'html-react-parser'

// Returns the markup for the details tab when editing a holiday
export default function HolidayDetails({ holiday }) {
    return (
        <>
            <div className='holiday-details-images'>
                {holiday.media?.primary_image?.startsWith('http') && (
                    <a className='holiday-details-image' href={holiday.media?.primary_image} target='_blank'>
                        <img src={holiday.media?.primary_image} />
                    </a>
                )}

                {holiday.media?.images?.filter((image) => image?.startsWith('http')).slice(0, 8).map((image, index) => (
                    <a key={image} className='holiday-details-image' href={image} target='_blank'>
                        <img key={index} src={image} />
                    </a>
                ))}
            </div>

            <div className='holiday-details-text'>
                {parse(holiday?.description, { replace: (domNode) => {
                    if (domNode.attribs && domNode.attribs.href) {
                        return <a href={`https://www.golfholidaysdirect.com${domNode.attribs.href}`} target='_blank'>{domNode.children[0].data}</a>
                    }
                } })}
            </div>
        </>
    )
}
